module.exports = __webpack_public_path__ + "images/emails/logo-beanstalk-db73bac7.png";